import api from './api';
import authHeader from './auth-header';

class TasksService {
    // Prehľad úloh celej firmy pre nástenku: počty z databázy + posledné dianie.
    getTasksOverview(limit = 8) {
        const url = `/chat/tasks-overview?limit=${encodeURIComponent(limit)}`;
        return api.get(url, { headers: authHeader() });
    }

    // Detail jednej úlohy vrátane mien, vlákna, priloženého zadania a nahrávok.
    getTaskDetails(taskId) {
        return api.get(`/chat/tasks/${taskId}/details`, { headers: authHeader() });
    }
}

const tasksService = new TasksService();
export default tasksService;
